import { AlertCircle } from 'lucide-react';
import { Link } from 'wouter';

import { AutoRedirect } from '@/components/auto-redirect';
import { PublicShell } from '@/components/public-shell';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export default function NotFound() {
  return (
    <PublicShell routeKey="not-found">
      <main className="page-shell-narrow flex min-h-[60vh] items-center justify-center">
        <Card className="w-full rounded-[1.75rem] border-border/70 shadow-sm">
          <CardContent className="space-y-5 pt-6 text-center">
            <div className="flex justify-center gap-2">
              <AlertCircle className="h-8 w-8 text-primary" />
              <h1 className="text-3xl font-semibold text-foreground">Page not found</h1>
            </div>

            <p className="text-sm leading-6 text-muted-foreground">
              That route does not exist anymore or the link is out of date. The safest next step is
              to jump back into your active region and start discovery again.
            </p>
            <AutoRedirect />
            <Link href="/">
              <Button className="rounded-full px-5">Go to regions</Button>
            </Link>
          </CardContent>
        </Card>
      </main>
    </PublicShell>
  );
}
